export const styles = {
  mainContainer: {
    width: '100%',
    backgroundColor: '#FFFFFF',
    borderRadius: '10px',
    margin: '10px 0',
    paddingBottom: '0.5em'
  },
  detailsContainer: {
    border: '0.6px solid #D7D7D7',
    borderRadius: '10px',
    height: 'max-content',
    margin: '1em'
  },
  dateNav: {
    borderBottom: '0.6px solid #D7D7D7',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '6px 10px 10px',
    fontSize: '14px',
    fontFamily: 'JioType-Medium'
  },
  metadata: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: '1em 0.8125em 0.8125em 1em',
    borderBottom: '0.6px solid #D7D7D7'
  },
  address: {
    fontFamily: 'JioType-Medium',
    width: '235px'
  },
  hospitalName: {
    fontSize: '14px',
    color: '#050000'
  },
  hospitalAddress: {
    fontSize: '12px',
    color: '#7D7D7D'
  },
  slotNumber: {
    fontFamily: 'JioType-Medium',
    fontSize: '14px'
  },
  slotName: {
    fontFamily: 'JioType-Bold',
    fontSize: '8px'
  },
  greaterThanTen: {
    background: 'rgb(72, 158, 66, 0.1)',
    borderRadius: '6px',
    color: '#489E42',
    width: '40px',
    height: '40px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginLeft: '0.5em'

  },
  lessThanTen: {
    background: 'rgb(235, 0, 0, 0.1)',
    borderRadius: '6px',
    color: '#EB0000',
    width: '40px',
    height: '40px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginLeft: '0.5em'

  },
  freeType: {
    background: '#489E42',
    borderRadius: '6px',
    width: '42px',
    height: '18px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginLeft: '0.5em',
    fontFamily: 'JioType-Bold',
    fontSize: '12px',
    color: '#FFFFFF',
    textTransform: 'uppercase'
  },
  paidType: {
    background: '#333333',
    borderRadius: '6px',
    width: '42px',
    height: '18px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginLeft: '0.5em',
    fontFamily: 'JioType-Bold',
    fontSize: '12px',
    color: '#FFFFFF',
    textTransform: 'uppercase'
  },
  displayDetailsContainer: {
    background: 'rgb(0, 40, 175, 0.05',
  },
  displayDetail: {
    height: '80px',
    padding: '1em',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderBottom: '0.6px solid #D7D7D7'
  },
  lastDetail: {
    height: '80px',
    padding: '1em',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderBottom: 'none'
  },
  columnFlex: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    alignItems: 'center'
  },
  headDetails: {
    color: '#7D7D7D',
    fontFamily: 'JioType-Medium',
    fontSize: '14px',
    marginBottom: '0.25em'
  },
  midDetails: {
    color: '#000000',
    fontFamily: 'JioType-Medium',
    fontSize: '12px',
    marginBottom: '0.5em'
  },
  paidFeeType: {
    width: '42px',
    height: '18px',
    background: '#EB0000',
    borderRadius: '6px',
    color: '#FFFFFF',
    fontFamily: 'JioType-Bold',
    fontSize: '12px',
    textTransform: 'uppercase'
  },
  freeFeeType: {
    width: '42px',
    height: '18px',
    background: '#489E42',
    borderRadius: '6px',
    color: '#FFFFFF',
    fontFamily: 'JioType-Bold',
    fontSize: '12px',
    textTransform: 'uppercase'
  },
  viewAllDates: {
    textAlign: 'center',
    // marginTop: '15px',
    color: '#0028AF',
    fontSize: '14px',
    fontFamily: 'JioType-Medium'
  },
  lessThanTenSlots: {
    fontFamily: 'JioType-Bold',
    fontSize: '10px',
    textTransform: 'lowercase',
    color: '#EB0000'
  },
  lessThanTenDose: {
    fontFamily: 'JioType-Medium',
    fontSize: '14px',
    color: '#EB0000'
  },
  greaterThanTenSlots: {
    fontFamily: 'JioType-Bold',
    fontSize: '10px',
    textTransform: 'lowercase',
    color: '#489E42'
  },
  greaterThanTenDose: {
    fontFamily: 'JioType-Medium',
    fontSize: '14px',
    color: '#489E42'
  },
  zeroSlots: {
    fontFamily: 'JioType-Bold',
    fontSize: '10px',
    textTransform: 'lowercase',
    color: '#7D7D7D'
  },
  zeroDose: {
    fontFamily: 'JioType-Medium',
    fontSize: '14px',
    color: '#7D7D7D'
  },
  cowinDiv: {
    display: 'flex',
    placeContent: 'center',
  },
  cowinButton: {
    width: '100%',
    height: '40px',
    background: '#0028AF 0% 0% no-repeat padding-box',
    boxShadow: '0px 0px 14px #0028AF33',
    borderRadius: '0px 0px 10px 10px',
    outline: 'none',
    textDecoration: 'none',
    border: 'none',
    color: '#fff',
    fontSize: '14px',
    fontFamily: 'JioType-Medium'
  }
}